<div class="tool-tip"
     [ngStyle]="{'top.px':mouseY, 'left.px':mouseX+24}"
     [ngClass]="{show:showTooltip, hide:!showTooltip}"
>
  <div class="item">
    rfid: {{tooltipValue}}
  </div>

</div>
